import { render, staticRenderFns } from "./form_text.vue?vue&type=template&id=46e61477&scoped=true&"
import script from "./form_text.vue?vue&type=script&lang=js&"
export * from "./form_text.vue?vue&type=script&lang=js&"
import style0 from "./form_text.vue?vue&type=style&index=0&id=46e61477&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e61477",
  null
  
)

export default component.exports